const lazyLoader = (loaderFunctions, timeout = 10000) => {
  let hasTriggered = false;

  const loadModules = async () => {
    if (hasTriggered) return;
    hasTriggered = true;

    // Remove event listeners once triggered
    document.removeEventListener('scroll', loadModules);
    document.removeEventListener('mousemove', loadModules);
    document.removeEventListener('touchstart', loadModules);
    document.removeEventListener('keydown', loadModules);
    document.removeEventListener('click', loadModules);

    // Execute all loader functions
    loaderFunctions.forEach(loader => {
      if (typeof loader === 'function') {
        loader();
      }
    });
  };

  // Add event listeners for first user interaction
  document.addEventListener('scroll', loadModules, { once: true, passive: true });
  document.addEventListener('mousemove', loadModules, { once: true, passive: true });
  document.addEventListener('touchstart', loadModules, { once: true, passive: true });
  document.addEventListener('keydown', loadModules, { once: true, passive: true });
  document.addEventListener('click', loadModules, { once: true, passive: true });

  // Fallback if no interaction occurs within timeout period
  setTimeout(loadModules, timeout);
};

export default lazyLoader;
